import { HttpClient, HttpHeaders } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { lastValueFrom, Observable, throwError, TimeoutError } from "rxjs";
import { catchError, tap, timeout } from "rxjs/operators";
import { IExecuteProcedureRequest } from "../model/pos.api.model";
import { environment } from "src/environments/environment";
import { ProcedureNameEnum } from "src/app/enums/procedure-name.enum";
import { TenderType } from "../model/tender-type.enum";

@Injectable({
  providedIn: "root",
})
export class SharedApiService {
  private _http = inject(HttpClient);
  private _apiAddress: string = environment.apiAddress;
  private _executeProcedureUrl: string = `${this._apiAddress}/api/dert/ExecuteProcedure`;
  private _headers = new HttpHeaders({
    "Country-Code": "cs-CZ",
  });

  /**
   * Default timeout for procedure execution (60 seconds).
   * Procedure calls can sometimes take longer for complex database operations.
   */
  private readonly DEFAULT_TIMEOUT = 60000;

  async executeProcedure<TParams, TResult>(
    request: IExecuteProcedureRequest<TParams>,
    timeoutMs?: number
  ): Promise<TResult> {
    return await lastValueFrom(
      this.executeProcedureObservable<TParams, TResult>(request, timeoutMs)
    );
  }

  executeProcedureObservable<TParams, TResult>(
    request: IExecuteProcedureRequest<TParams>,
    timeoutMs: number = this.DEFAULT_TIMEOUT
  ): Observable<TResult> {
    return this._http.post<TResult>(this._executeProcedureUrl, request, {
      headers: this._headers,
    }).pipe(
      timeout(timeoutMs),
      catchError((error) => {
        if (error instanceof TimeoutError) {
          console.error(`Procedure ${request.ProcedureName} timed out after ${timeoutMs}ms`);
          // Returning a specific translation key that callers can identify and translate
          return throwError(() => new Error('webPos.Errors.TimeoutError'));
        }
        return throwError(() => error);
      })
    );
  }
}
